export const REACT_APP_CHAIN_ID = process.env.REACT_APP_CHAIN_ID || '';
export const REACT_APP_INFURA_URL = process.env.REACT_APP_INFURA_URL || '';
export const REACT_APP_BSC_API_KEY = process.env.REACT_APP_BSC_API_KEY || '';
export const REACT_APP_CONTRACT_URL = process.env.REACT_APP_CONTRACT_URL || '';

export const CONTRACT_ADDRESS = REACT_APP_CONTRACT_URL.split('/').slice(-1)[0];
export const INFURA_ID = REACT_APP_INFURA_URL.split('/').slice(-1)[0];
